<template>
  <div>
    <div>
      <b-row align-v="center" align-h="between">
        <b-col align-self="center"
          ><b-form-input
            v-model="search.code"
            placeholder="جستجو بر اساس کد"
            class="mb-3"
            maxlength="11"
            @keydown.enter="updateDevices"
          ></b-form-input>
        </b-col>
        <b-col align-v="center" align-h="between">
          <button
            type="button"
            class="btn btn-primary mb-3"
            title="جستجو"
            @click="updateDevices"
          >
            <i class="fal fa-search pt-1" />
            جستجو
          </button>
        </b-col>
        <b-col>
          <div class="d-flex justify-content-end">
            <div class="alert d-flex align-items-right bg-primary">
              <span class="text-white font-size-sm font-weight-bold m-0">
                تعداد دستگاه ها:

                {{ numberFormat(adminDevicesPagination.total) }}
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <div>
      <div v-if="loaded && adminDevices.length === 0">
        <div class="alert alert-primary" role="alert">دستگاهی یافت نشد.</div>
      </div>
    </div>
    <div v-if="loaded && adminDevices.length" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>نوع</th>
                <th>کد</th>
                <th>نام</th>
                <th>کاربر</th>
                <th>
                  تاریخ ثبت
                </th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="device in adminDevices" :key="device.id">
                <!-- <td>{{ device.first_name || "_" }}</td> -->
                <td>{{ typesTrans[device.type] }}</td>
                <td>{{ device.code }}</td>
                <td>{{ device.name }}</td>
                <td>
                  <span v-if="device.user">{{ gFullName(device.user) }}</span>
                </td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(device.created_at) }}
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'admin-devices-show',
                      params: { id: device.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>
                  <router-link
                    :to="{
                      name: 'admin-devices-edit',
                      params: { id: device.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-edit"></i>
                    ویرایش
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-5" v-if="adminDevicesPagination.lastPage > 1">
      <b-pagination
        v-model="adminDevicesPagination.currentPage"
        :total-rows="adminDevicesPagination.total"
        :per-page="adminDevicesPagination.perPage"
        aria-controls="my-table"
        @input="updateDevices()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_ADMIN_DEVICES,
  DESTROY_ADMIN_DEVICE
} from "@/core/services/store/admin/devices.module.js";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "adminDevices",
  data() {
    return {
      loaded: false,
      searchDevice: "",
      search: {
        cellphone: "",
        company: null
      }
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "مدیریت",
        route: { name: "admin-dashboard" }
      },
      { title: "دستگاه ها" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {
      links: [
        {
          name: '<i class="flaticon2-plus"></i>افزودن',
          to: { name: "admin-devices-create" },
          class: "btn-primary"
        }
      ]
    });

    this.updateDevices();
  },
  computed: {
    ...mapGetters(["adminDevices", "adminDevicesPagination", "typesTrans"])
  },
  methods: {
    updateDevices() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_ADMIN_DEVICES, {
          cellphone: this.search.cellphone,
          company: this.search.company
        })
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    destroy(id) {
      Swal.fire({
        title: "",
        text: "آیا از حذف دستگاه اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_ADMIN_DEVICE, id).then(() => {
            this.updateDevices();
          });
        }
      });
    }
  }
};
</script>
